import * as React from 'react';
export const historySvg = React.forwardRef(function historySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'm3.987 5.538-1.444-.48C3.697 2.54 5.966 1.5 8 1.5c3.586 0 6.5 2.914 6.5 6.5s-2.914 6.5-6.5 6.5c-3.125 0-5.373-1.99-6.289-4.737a.75.75 0 1 0-1.423.474C1.373 13.491 4.125 16 8 16c4.414 0 8-3.586 8-8s-3.586-8-8-8C5.636 0 3.005 1.139 1.5 3.804V1.75a.75.75 0 0 0-1.5 0v3.5c0 .323.207.61.513.712l3 1a.75.75 0 1 0 .474-1.424Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.5 4.25a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 .494.705l2.75 1a.75.75 0 1 0 .512-1.41L8.5 8.225V4.25Z',
    }),
  );
});
historySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var history = {
  category: 'icon',
  colorable: true,
  name: 'history',
  svg: historySvg,
};
